import { constants } from '../config';

/* **** showLoading *** */
export const showLoading = (value, percent) => ({
  type: constants.SHOW_LOADING,
  value,
  percent,
});
